import script from "./ResourceDocumentView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceDocumentView.vue?vue&type=script&setup=true&lang=js"

import "./ResourceDocumentView.vue?vue&type=style&index=0&id=bc06f062&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc06f062"]])

export default __exports__